export const menu = {
  container: {
    maxHeight: 'menu.max-height',
  },
};
